import { useState, useRef, ChangeEvent } from 'react';

export function useImageAttachment() {
  const [selectedImage, setSelectedImage] = useState<File | null>(null);
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleImageSelect = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // Check if file is an image
    if (!file.type.startsWith('image/')) {
      console.error('Selected file is not an image');
      return;
    }

    setSelectedImage(file);
    // Clear the file input value so the same file can be selected again
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleRemoveImage = () => {
    setSelectedImage(null);
  };

  const triggerImageSelect = () => {
    fileInputRef.current?.click();
  };

  return {
    image: selectedImage,
    fileInputRef,
    onSelect: handleImageSelect,
    onRemove: handleRemoveImage,
    onTriggerSelect: triggerImageSelect
  };
} 